












































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import STextarea from '@/common/components/STextarea.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default defineComponent({
  name: 'Chem1301Lab3Calculations',
  components: {CalculationInput, STextarea, TableInput, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        step18Calc: null,
        step20Calc: null,
        step32Calc2: null,
        step36Calc2: null,
      },
      rows: [
        {
          step: '',
          input: 'step18Calc',
          calc: true,
          question: 'What is the pH of a 0.1 M solution of HCl?',
        },
        {
          step: '',
          input: 'step20Calc',
          calc: true,
          question: 'What is the pH of a 0.1 M solution of NaOH?',
        },
        {
          step: '33',
          input: 'step32Calc2',
          calc: true,
          question: 'Calculate the expected pH of the diluted acid solution.',
        },
        {
          step: '37',
          input: 'step36Calc2',
          calc: true,
          question: 'Calculate the expected pH of the diluted base solution.',
        },
      ],
    };
  },
});
